<div class="bulletin-board">
  <div class="title-container">
    <span class="title">Bulletin Board</span>
  </div>
  <div class="content">
    <div class="top-section">
      <app-new-button
        leftIcon="arrow_back"
        size="sm"
        (clickHandler)="goBack()"
        color="bare"
      >Back</app-new-button>
      <span class="top-section-title">View Full Post</span>
    </div>
    <div class="bottom-section">
      <app-loading-spinner class="spinner" *ngIf="isLoading"></app-loading-spinner>
      <ng-container *ngIf="!isLoading">
        <div class="left-side">
          <div *ngIf="permissions.EDIT_BULLETIN_BOARD === 1" class="actions-and-info">
            <div class="label-container">
              <span class="label">Actions & Info</span>
            </div>
            <div class="action" (click)="editPost()">
              <mat-icon class="material-icons-outlined edit-icon">edit</mat-icon>
              <span class="action-label">Edit Post</span>
            </div>
            <div class="action" (click)="deletePost()">
              <mat-icon class="material-icons-outlined delete-icon">delete</mat-icon>
              <span class="action-label">Delete Post</span>
            </div>
          </div>
          <div class="metadata">
            <div class="label-container">
              <span class="label">Metadata</span>
            </div>
            <div class="metadatum">
              <span class="metadatum-label">Author</span>
              <span class="metadatum-value">{{post?.publishedBy}}</span>
            </div>
            <div class="metadatum">
              <span class="metadatum-label">Post On</span>
              <span class="metadatum-value">{{getPostTime()}}</span>
            </div>
          </div>
        </div>
        <div class="right-side">
          <div class="post-title-container">
            <span class="post-title">{{ post?.title }}</span>
          </div>
          <div class="post-content-container">
            <span class="post-content" [innerHTML]="post?.content"></span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
